import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

export default function Faq({ faqs }) {
  return (
    <section id="faq" className="py-20 lg:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <SectionHead eyebrow="Questions, Answered" title="Frequently Asked Questions" />
        <Reveal delay={0.1}>
          <Accordion.Root type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <Accordion.Item key={i} value={`faq-${i}`} className="border-b border-navy-700" data-testid={`faq-item-${i}`}>
                <Accordion.Trigger className="group flex w-full items-center justify-between gap-4 py-5 text-left font-serif text-lg font-semibold text-ivory transition-colors hover:text-gold" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                  <ChevronDown className="h-5 w-5 shrink-0 text-gold transition-transform duration-300 group-data-[state=open]:rotate-180" />
                </Accordion.Trigger>
                <Accordion.Content className="overflow-hidden text-sm leading-relaxed text-slate-400 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                  <p className="pb-5 pr-8">{f.a}</p>
                </Accordion.Content>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </Reveal>
      </div>
    </section>
  );
}
